import RequestManager from "../../singletons/RequestManager";
export default class OrderStatusManager {
  updateOrderStatus = async (orderId, status, printCount, refreshOrders) => {
    console.log("orderId", orderId);
    let requestManager = new RequestManager();
    let params;
    if (status === "") {
      params = {
        input: {
          id: orderId,
          printLinesCount: printCount,
        },
      };
    } else {
      if (printCount > 0) {
        params = {
          input: {
            id: orderId,
            printLinesCount: printCount,
            status: status,
          },
        };
      } else {
        params = {
          input: {
            id: orderId,
            status: status,
          },
        };
      }
    }
    console.log("orderId", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log("updateOrder", JSON.stringify(response));
    if (response.error === null) {
      if (refreshOrders){
        console.log('refreshorders from order manager');
        refreshOrders();
      }
      return true;
    } else {
      if (refreshOrders){
        console.log('refreshorders update failed from order manager');
        refreshOrders();
      }
      return false;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/OrderStatusManager.js